import React from 'react'
import Btn from './Btn'

const NotFound: React.FC = () => {
  return (
    <div className={'not-found'}>
      <div className={'not-found__content'}>
        <h1>Страница не найдена</h1>
        <p className={'mt-md-10 mt-sm-8'}>
          Эта страница в данный момент недоступна или была удалена.
        </p>
        <Btn className={'mt-md-14 mt-sm-10'} to={'/'}>
          На главную
        </Btn>
        <div className={'not-found__picture'}>
          <img src={'/i/404.png'} alt="not found" />
        </div>
      </div>
    </div>
  )
}

export default NotFound
